import { toast } from "react-toastify";

export function emitErrorToast(message = "") {
  toast.error(message, {
    position: "bottom-left",
    autoClose: 2000,
  });
}

export function emitSuccessToast(message = "") {
  toast.success(message, {
    position: "bottom-left",
    autoClose: 2000,
  });
}
